const TRACKING_TIMEOUT_MS = 500;

// Segment sends each event as its own non-keepalive fetch, which the browser cancels if a
// navigation unloads the page first. Callers await this before redirecting; the cap keeps a
// slow or blocked Segment call from stranding the user.
async function waitForTracking(
  track: () => Promise<unknown> | undefined,
  timeoutMs: number = TRACKING_TIMEOUT_MS
): Promise<void> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    await Promise.race([
      track(),
      new Promise((resolve) => {
        timer = setTimeout(resolve, timeoutMs);
      })
    ]);
  } catch {
    // Tracking failure must never block navigation.
  } finally {
    clearTimeout(timer);
  }
}

export { waitForTracking };
